import { Component } from '@angular/core';
import { CoreComponent } from '../core.component';

@Component({
  selector: 'not-found-error',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent extends CoreComponent {
  refresh() {
    window.location.href = '/ro/calculator';
  }

  back() {
    history.back();
  }
}
